var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.16203219 1.39173727c1.04617304-1.38498522 2.50060362-1.39173727 2.50060362-1.39173727s.21634407 1.30212151-.82297585 2.55647947c-1.10973441 1.33937603-2.3711006 1.12021019-2.3711006 1.12021019s-.23685111-1.05337275.69347283-2.28495239zm-.56041247 3.19708375c.53820523 0 1.53708652-.7430936 2.83726962-.7430936 2.23804026 0 3.11848286 1.59955337 3.11848286 1.59955337s-1.7219899.8843087-1.7219899 3.03004269c0 2.42057142 2.1451308 3.25477832 2.1451308 3.25477832s-1.4995252 4.2392644-3.52496179 4.2392644c-.93027163 0-1.65351107-.6296749-2.63369014-.6296749-.99888129 0-1.99012475.6531626-2.63573039.6531626-1.84953118.0000525-4.18613078-4.0213334-4.18613078-7.25385883 0-3.18034811 1.97777867-4.84870936 3.83285513-4.84870936 1.2059658 0 2.14180885.69853531 2.76876459.69853531z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.803807156d42bf7de406d80ec47ed781.svg";
export { ForwardRef as ReactComponent };